import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Base abstract component to handle automatic unsubscription 
 * using the takeUntil(this.destroy$) pattern.
 * 
 * Usage:
 * someObservable.pipe(takeUntil(this.destroy$)).subscribe(...)
 */
@Component({
  template: ''
})
export abstract class BaseComponent implements OnDestroy {
  protected destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
